import React from 'react';
import LensIcon from '@material-ui/icons/Lens';
import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';
import { createStyles, withStyles } from '@material-ui/core/styles';

const green300 = green['300'];
const red300 = red['300'];

const styles = createStyles({
  green: {
    color: green300,
    height: 11,
    width: 11
  },
  red: {
    color: red300,
    height: 11,
    width: 11
  }
});

type Props = {
  classes: any,
  enabled: boolean,
  style?: any
};

const StatusIconSmall = (props: Props) => (
  <LensIcon className={props.enabled ? props.classes.green : props.classes.red} style={props.style} />
);

export default withStyles(styles)(StatusIconSmall);



// WEBPACK FOOTER //
// ./src/views/Common/Icons/StatusSmall.tsx